import { TestAppState } from "../../app";

/**
 * How the program reports status, defaulted the way every call site already
 * defaulted it.
 *
 * `Configuration["statusReportingLevel"]` is `"overall" | "category"` and
 * nothing else, so the two values are exhaustive — which is what lets the
 * status card and the project-status donut each be one component that picks a
 * shape, rather than two components sharing one `componentId` and taking turns
 * being visible.
 */
export function statusReportingLevel(
  settings: TestAppState["settings"]
): "overall" | "category" {
  return settings?.configuration?.statusReportingLevel ?? "overall";
}
